import { LANGUAGES } from '../../../components/translations/translationModal';
import { unifyItaly } from '../../../components/utils/locales';

export const getProductsLanguages = organization => unifyItaly(organization.languages);

export const removeDefaultLanguage = (translations, default_lang) => {
    Object.keys(translations).forEach(key => {
        delete translations[key][default_lang];
    });
    return translations;
};

export const setTranslate = (string, lang, productLangs) => {
    let reg = new RegExp(/\[([a-z]{2}[-|_]?[A-Z]{0,2})\](.*)/);
    const pipeTranslations = {};
    if (string.includes('|')) {
        string.split('|').forEach(item => {
            let matches = item.match(reg);
            //we use the account current language (or similar langauges) or en-GB as fallback
            if (matches) {
                let languageKey = matches[1].replace('_', '-').toLowerCase();
                if (!productLangs.includes(languageKey)) {
                    languageKey = productLangs.find(l => l.includes(languageKey.split('-')[0]));
                    if (!Object.keys(pipeTranslations).includes(languageKey)) pipeTranslations[languageKey] = matches[2];
                } else pipeTranslations[languageKey] = matches[2];
            }
        });
    } else return string;
    //if account language and en-GB weren't found we display raw pipetranslate
    return pipeTranslations[lang] || pipeTranslations[Object.keys(pipeTranslations).find(l => productLangs.includes(l))] || string;
};

export const getLanguagesTranslateDropdown = locales => {
    return locales.map(lang => {
        return {
            label: LANGUAGES[lang],
            value: lang
        };
    });
};

export const getDefaultLanguage = (organization, productsLanguages) => {
    // default language is default_locale from organization. If organization default language
    // is not in the default language list then we return english
    const languageOrga = organization
        .defaultLanguage()
        .replace('_', '-')
        .split('-')[0];
    let localeDefaultOrga = productsLanguages.find(lang => lang?.split('-')[0] === languageOrga);
    return localeDefaultOrga ? localeDefaultOrga.toLowerCase() : 'en-gb';
};
